import { Grid, Typography } from "@mui/material"
import { BackIcon } from "../../utils/iconRefs/recipeStepsIcons"

type Props = {
  text: string,
  onClickBack: () => void,
}

const ViewRecipeHeader = ({ text, onClickBack }: Props): JSX.Element => {
  return (
    <Grid container sx={{ maxWidth: '960px', boxSizing: 'border-box', boxShadow: '0px 1px 4px 0px #00000040', justifyContent: 'space-between', padding: '20px 0 10px 0', position: 'fixed', backgroundColor: '#fff', zIndex: 5 }}>
      <Grid alignItems="center" container
        spacing={1}>
        <Grid container item justifyContent='center'
          onClick={onClickBack} xs={1.5}>
          <BackIcon />
        </Grid>
        <Grid item xs={10}>
          <Typography textOverflow="clip" variant="h6">{text}</Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ViewRecipeHeader;